/**
 * Модуль для боевых анимаций
 */

/**
 * Создает менеджер для управления боевыми анимациями
 */
export function createBattleAnimationsManager({
  getBattleState,
  getPanelById
}) {
  /**
   * Анимация существа по ID
   * @param {string|number} creatureId - ID существа
   * @param {string} animationType - Тип анимации (focus, hit, evolved и т.д.)
   * @param {number} duration - Длительность анимации в миллисекундах (по умолчанию 600)
   */
  function animateCreature(creatureId, animationType, duration = 600) {
    if (!creatureId) return;
    
    const battleState = getBattleState();
    if (!battleState || !battleState.panels) return;
    
    const panel = getPanelById(battleState.panels, creatureId);
    if (!panel) return;
    
    const element = document.querySelector(`[data-panel-id="${creatureId}"]`);
    if (!element) return;
    
    const className = `battle-animate-${animationType}`;
    element.classList.add(className);
    
    setTimeout(() => {
      element.classList.remove(className);
    }, duration);
  }

  /**
   * Анимация команды по ID
   * @param {string} teamId - ID команды
   * @param {string} animationType - Тип анимации (attack, hit, evolution и т.д.)
   * @param {number} duration - Длительность анимации в миллисекундах (по умолчанию 600)
   */
  function animateTeam(teamId, animationType, duration = 600) {
    if (!teamId) return;
    
    const elements = document.querySelectorAll(`[data-team="${teamId}"], .battle-team-${teamId}`);
    if (!elements || elements.length === 0) return;
    
    const className = `battle-animate-team-${animationType}`;
    
    elements.forEach(element => {
      element.classList.add(className);
      setTimeout(() => {
        element.classList.remove(className);
      }, duration);
    });
  }

  /**
   * Показ урона по существу
   * @param {string|number} creatureId - ID существа
   * @param {number} damage - Величина урона
   * @param {boolean} isCrit - Критический удар (по умолчанию false)
   */
  function showCreatureDamage(creatureId, damage, isCrit = false) {
    if (!creatureId || !damage) return;
    
    const element = document.querySelector(`[data-panel-id="${creatureId}"]`);
    if (!element) return;
    
    const damageElement = document.createElement('div');
    damageElement.className = `battle-damage ${isCrit ? 'battle-damage--crit' : ''}`;
    damageElement.textContent = isCrit ? `💥 ${damage}` : damage;
    damageElement.style.cssText = `
      position: absolute;
      color: ${isCrit ? '#ff0000' : '#ff6b6b'};
      font-weight: 700;
      font-size: 18px;
      pointer-events: none;
      z-index: 1000;
      animation: damageFloat 1s ease-out forwards;
    `;
    
    element.style.position = 'relative';
    element.appendChild(damageElement);
    
    setTimeout(() => {
      if (damageElement.parentNode) {
        damageElement.parentNode.removeChild(damageElement);
      }
    }, 1000);
  }

  /**
   * Показ урона по команде
   * @param {string} teamId - ID команды
   * @param {number} damage - Величина урона
   * @param {boolean} isCrit - Критический удар (по умолчанию false)
   */
  function showTeamDamage(teamId, damage, isCrit = false) {
    if (!teamId || !damage) return;
    
    const elements = document.querySelectorAll(`[data-team="${teamId}"], .battle-team-${teamId}`);
    if (!elements || elements.length === 0) return;
    
    elements.forEach(element => {
      const damageElement = document.createElement('div');
      damageElement.className = `battle-damage ${isCrit ? 'battle-damage--crit' : ''}`;
      damageElement.textContent = isCrit ? `💥 ${damage}` : damage;
      damageElement.style.cssText = `
        position: absolute;
        color: ${isCrit ? '#ff0000' : '#ff6b6b'};
        font-weight: 700;
        font-size: 18px;
        pointer-events: none;
        z-index: 1000;
        animation: damageFloat 1s ease-out forwards;
      `;
      
      element.style.position = 'relative';
      element.appendChild(damageElement);
      
      setTimeout(() => {
        if (damageElement.parentNode) {
          damageElement.parentNode.removeChild(damageElement);
        }
      }, 1000);
    });
  }

  return {
    animateCreature,
    animateTeam,
    showCreatureDamage,
    showTeamDamage
  };
}





